import axios from "axios";
import store from "@/store/store";
import i18n from '@/i18n'
import flatten from 'flat'
import _ from 'lodash'

const API = {
    URL: process.env.VUE_APP_API_URL,

    get (url, config = {}) {
        return axios.get(this.URL + url, config)
            .catch(error => {
                this._resolveError(error, config.preserveError);
            });
    },

    delete (url, config = {}) {
        return axios.delete(this.URL + url, config)
            .catch(error => {
                this._resolveError(error, config.preserveError);
            });
    },

    post (url, data = {}, config = {}) {
        return axios.post(this.URL + url, data, config)
            .catch(error => {
                this._resolveError(error, config.preserveError);
            });
    },

    put (url, data = {}, config = {}) {
        return axios.put(this.URL + url, data, config)
            .catch(error => {
                this._resolveError(error, config.preserveError);
            });
    },

    patch (url, data = {}, config = {}) {
        return axios.patch(this.URL + url, data, config)
            .catch(error => {
                this._resolveError(error, config.preserveError);
            });
    },

    _resolveError (error, preserveError = false) {
        const status = error.response?.status;
        if (status === 401) { // unauthorized
            // clean up old auth info
            store.commit('identity/removeAuthInfo');
            // force redirect to '/login' route
            window.location.replace('/login');
        }
        throw preserveError ? error : this.errorMessage(error);
    },

    errorMessage (error) {
        if (_.isString(error)) {
            return error;
        }
        const status = error.response?.status;
        if ([403, 404].includes(status)) {
            return i18n.t('snackbar.error.' + status);
        }
        let errors = error.response?.data?.errors;
        if (_.isArray(errors)) {
            errors = errors[0]
        }
        if (_.isString(errors)) {
            return errors;
        }
        if (_.isObject(errors)) {
            errors = flatten(errors);
            if (Object.values(errors).length > 0) {
                return "" + Object.keys(errors)[0] + ": " + Object.values(errors)[0];
            }
        }
        return i18n.t('snackbar.unknown_error');
    }
};

export { API };
